// Disable form submissions if there are invalid fields
(() => {
  const forms = document.getElementsByClassName('needs-validation');
  const mainContent = document.querySelector('#main-content');
  if (forms) {
    window.addEventListener(
      'load',
      () => {
        // Fetch all the forms we want to apply, loop over them
        // and prevent submission and scroll top
        Array.prototype.filter.call(forms, form => {
          form.addEventListener(
            'submit',
            event => {
              if (form.checkValidity() === false) {
                mainContent.scrollIntoView();
                event.preventDefault();
                event.stopPropagation();
              }
              form.classList.add('was-validated');
            },
            false
          );
        });
      },
      false
    );
  }
})();
